import { render, staticRenderFns } from "./StudyNewPageScreeningBody.vue?vue&type=template&id=7c03b4a0&scoped=true"
import script from "./StudyNewPageScreeningBody.vue?vue&type=script&lang=js"
export * from "./StudyNewPageScreeningBody.vue?vue&type=script&lang=js"
import style0 from "./StudyNewPageScreeningBody.vue?vue&type=style&index=0&id=7c03b4a0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c03b4a0",
  null
  
)

export default component.exports